import { GridCellProps } from "@progress/kendo-react-grid";
import CircleColor from "../../commons/components/CircleColor";

export default function EchantillonCell(props: GridCellProps) {
    return <td colSpan={1} className="k-table-td" role="gridcell" aria-colindex={3} aria-selected="false" data-grid-col-index="2"><CircleColor colors={props.dataItem.couleurs} editMode={"echantillon"} /></td>;
}